import { useState, useMemo } from 'react';
import get from 'lodash/get';
import { SUBSCRIPTION_STATUS } from '../../constants';

const useProgramSubscription = ({ program }) => {
  const { subscriptionOption = {}, subscriptionsSettings = [] } = {
    ...program,
  };

  const subscriptionOptionStatus = get(subscriptionOption, 'status');

  const isSubscriptionStatusPending =
    subscriptionOptionStatus === SUBSCRIPTION_STATUS.PENDING;

  const prepaidByProvider =
    subscriptionOptionStatus === SUBSCRIPTION_STATUS.PREPAID;

  const subscriptionsSettingId = get(
    subscriptionOption,
    'subscriptionsSettingId',
    null,
  );

  const initSubscriptionsSettingId = useMemo(() => {
    if (!isSubscriptionStatusPending && subscriptionsSettingId) {
      return subscriptionsSettingId;
    }

    return '';
  }, [subscriptionsSettingId, isSubscriptionStatusPending]);

  const [selectedMembershipId, setSelectedMembershipId] = useState(
    initSubscriptionsSettingId,
  );

  const onlyOneSubscriptionOption = subscriptionsSettings.length === 1;

  const moreThanOneSubscriptionOption = subscriptionsSettings.length > 1;

  const subscriptionsSetting = useMemo(() => {
    if (onlyOneSubscriptionOption) {
      return subscriptionsSettings[0];
    }

    return subscriptionsSettings.find(
      ({ id: subscriptionId }) => subscriptionId === selectedMembershipId,
    );
  }, [subscriptionsSettings, selectedMembershipId, onlyOneSubscriptionOption]);

  const handleChangeMembershipDuration = membershipId => {
    setSelectedMembershipId(membershipId);
  };

  return {
    handleChangeMembershipDuration,
    isSubscriptionStatusPending,
    moreThanOneSubscriptionOption,
    prepaidByProvider,
    selectedMembershipId,
    subscriptionsSetting,
  };
};

export default useProgramSubscription;



// WEBPACK FOOTER //
// ./src/hooks/program/useProgramSubscription.js